import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { OverflowContainer, PulseWrapper } from '../List.styles';
import { connectionShape } from '../helperFunctions';
import { STable, Styles } from '@/customComponents/BuildingBlocks/SortableTable/SortableTable';

class ConnectionTable extends PureComponent {
  resolveMessages = () => {
    const { messages } = this.props;
    return { ...ConnectionTable.defaultProps.messages, ...messages };
  };

  getRows = () => {
    const { data } = this.props;
    const { externalSystemLabel, hotelCodeLabel, chainCodeLabel, primaryRoomCodeLabel } = this.resolveMessages();

    if (!data) return null;

    return data.map((connection) => {
      const { id, handleRemove, handleEdit, extSystem, hotelCode, chainCode, primaryRoomCode } = connection;
      return {
        id,
        columns: [
          {
            value: extSystem.name,
            columnId: 'extSystem',
            label: STable.columnLabel(externalSystemLabel, extSystem.name)
          },
          {
            value: hotelCode,
            columnId: 'hotelCode',
            label: STable.columnLabel(hotelCodeLabel, hotelCode)
          },
          {
            value: chainCode,
            columnId: 'chainCode',
            label: STable.columnLabel(chainCodeLabel, chainCode)
          },
          {
            value: primaryRoomCode ? 'Primary' : 'Secondary',
            columnId: 'primaryRoomCode',
            label: STable.columnLabel(primaryRoomCodeLabel, primaryRoomCode ? 'Primary' : 'Secondary')
          },
          {
            columnId: 'buttons',
            label: (
              <Styles.Details>
                {handleEdit && (
                  <Styles.ButtonsContainer>
                    <Styles.StyledButton className="first" onClick={() => handleEdit(id)}>
                      Edit
                    </Styles.StyledButton>
                  </Styles.ButtonsContainer>
                )}
                {handleRemove && (
                  <Styles.StyledRemove type="button" onClick={() => handleRemove(id)}>
                    Remove
                  </Styles.StyledRemove>
                )}
              </Styles.Details>
            )
          }
        ]
      };
    });
  };

  render() {
    const { externalSystemLabel, hotelCodeLabel, chainCodeLabel, primaryRoomCodeLabel } = this.resolveMessages();

    return (
      <OverflowContainer>
        <PulseWrapper>
          <STable
            defaultSort="hotelCode"
            columns={[
              { id: 'extSystem', label: externalSystemLabel },
              { id: 'hotelCode', label: hotelCodeLabel },
              { id: 'chainCode', label: chainCodeLabel },
              { id: 'primaryRoomCode', label: primaryRoomCodeLabel },
              { id: 'buttons', unSortable: true }
            ]}
            rows={this.getRows()}
          />
        </PulseWrapper>
      </OverflowContainer>
    );
  }
}

ConnectionTable.propTypes = {
  data: PropTypes.arrayOf(connectionShape).isRequired,
  messages: PropTypes.shape({})
};

ConnectionTable.defaultProps = {
  messages: {
    externalSystemLabel: 'External System',
    hotelCodeLabel: 'Hotel Code',
    chainCodeLabel: 'Chain Code',
    capabilitiesLabel: 'Capabilities',
    actionHeaderLabel: '',
    primaryRoomCodeLabel: 'Room Code Type'
  }
};

export default ConnectionTable;
